<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="currentTab" :stepTitle="stepTitle"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">房型信息</span>
            </a-col>
          </a-row>
          <a-button :disabled="proSource!=0" class="mr5" type="primary" @click="onNewClickOption(0)">新建房型</a-button>
          <a-dropdown-button :disabled="proSource!=0">批量操作
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item :key="2">批量改价</a-menu-item>
              <a-menu-item :key="3">批量库存</a-menu-item>
              <a-menu-item :key="1">批量上架</a-menu-item>
              <a-menu-item :key="0">批量下架</a-menu-item>
            </a-menu>
          </a-dropdown-button>
          <custom-page-table
            style="margin-top: 15px;"
            ref="table"
            rowKey="optionId"
            :queryParams="queryParams"
            :requestPromise="loadPromise"
            :columns="getColumns()"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <template slot="statusSlot" slot-scope="rowItem">{{ rowItem.record.optionStatus | getProOptionStatusStr }}
            </template>
            <span slot="action" slot-scope="rowItem">
              <a v-if="rowItem.record.optionStatus==1" @click="handleUpDownOption(rowItem.record,0)"
                 :disabled="proSource!=0">下架</a>
              <a v-else :disabled="proSource!=0" @click="handleUpDownOption(rowItem.record,1)">上架</a>
              <a-divider type="vertical"></a-divider>
              <a @click="editOption(rowItem.record)">编辑</a>
              <a-divider type="vertical"></a-divider>
              <span v-if="rowItem.record.mark==1">
                <a :disabled="proSource!=0" @click="onPlanUpdate(rowItem.record,0)">新建计划</a>
                <a-divider type="vertical"></a-divider>
              </span>
              <span v-if="rowItem.record.mark==2">
                <a @click="goSetPrice(rowItem.record)">价格库存</a>
                <a-divider type="vertical"></a-divider>
              </span>
              <a-popconfirm title="是否要删除当前行" @confirm="onDeleteType(rowItem.record)">
                <a :disabled="proSource!=0">删除</a>
              </a-popconfirm>
              <span v-if="rowItem.record.mark==1">
                <a-divider type="vertical"></a-divider>
                <a @click="onCopyType(rowItem.record.optionId)" :disabled="proSource!=0">复制</a>
              </span>
              <span v-if="openWelfare && rowItem.record.mark==2 && proSource == 0">
                <a-divider type="vertical"/>
                <AppointDistribution :dataObj="rowItem.record" @refresh="refreshEvent"/>
              </span>
            </span>
          </custom-page-table>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
      <HotelBatchChange :visible="popupVisible" :priceOrStock="priceOrStock"
                        :selectedRowsIdList="selectedRowsIdList"
                        @changeClose="changePopupClose"></HotelBatchChange>
    </div>
    <a-modal v-model="visibleError" title="上架失败的房型或价格计划" ok-text="确认" cancel-text="取消" @ok="hideModal">
      <p v-if="optionErrorIds&&optionErrorIds.length>0">
        <span>上架失败的房型ID：</span>
        <span v-for="(item,index) in optionErrorIds"
              :key="index">{{ item }}{{ index == optionErrorIds.length - 1 ? '' : ',' }}</span>
      </p>
      <p v-if="ratePlanErrorIds&&ratePlanErrorIds.length>0">
        <span>上架失败的价格计划ID：</span>
        <span v-for="(item,index) in ratePlanErrorIds"
              :key="index">{{ item }}{{ index == ratePlanErrorIds.length - 1 ? '' : ',' }}</span>
      </p>
    </a-modal>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import PublishPro from '../components/PublishPro'
import HotelBatchChange from '../components/HotelBatchChange'
import welfareMallMixins from '@/utils/mixins/welfareMallMixins'

export default {
  name: 'HotelOptionList',
  mixins: [welfareMallMixins],
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro,
    HotelBatchChange
  },
  data() {
    return {
      visibleError: false,
      popupVisible: false,
      submitLoading: false,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      selectedRowKeys: [],
      selectedRows: [],
      queryParams: {
        proId: this.$route.query.proId
      },
      loadPromise: params => this.getListPromise(params),
      stepTitle: '',
      submitFormData: '',
      teamRouteList: [],
      currentTab: 2,
      priceOrStock: 0,
      selectedRowsIdList: [],
      optionErrorIds: [],
      ratePlanErrorIds: []
    }
  },
  mounted() {
    this.getWelfareInfo() // 获取福利商城信息
  },
  methods: {
    hideModal() {
      this.visibleError = false
    },
    handleMenuClick(e) {
      let key = e.key
      this.priceOrStock = key
      this.getLogUtils().logWithTag('handleMenuClick', key)
      if (key == 1 || key == 0) {
        this.handleAllOption(key)
      } else {
        if (this.selectedRowKeys.length > 0) {
          this.popupVisible = true
        } else {
          this.$message.warning('请选择需要操作的数据')
        }
      }
    },
    changePopupClose() {
      this.popupVisible = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      let list = []
      for (let item of this.selectedRows) {
        this.getLogUtils().logWithTag('item', item)
        let obj = {}
        obj.optionId = item.ratePlanOptionId
        // obj.ratePlanIds = item.optionId;
        obj.ratePlanIds = item.mark == 1 ? 0 : item.optionId
        list.push(obj)
      }
      this.selectedRowsIdList = list
      this.getLogUtils().logWithTag('selectedRows', this.selectedRows)
      this.getLogUtils().logWithTag('selectedRowsIdList', this.selectedRowsIdList)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('api/v2/productManage/findOptionList', params)
    },
    getColumns() {
      document.title = '酒店-房型/价格计划'
      this.stepTitle = '房型/价格计划'
      return [
        {
          title: '房型/价格计划名称',
          dataIndex: 'optionName'
        }, {
          title: '房型/计划编号',
          dataIndex: 'optionId'
        }, {
          title: '状态',
          dataIndex: 'optionStatus',
          scopedSlots: { customRender: 'statusSlot' },
          fixed: 'right'
        }, {
          title: '操作',
          dataIndex: 'action',
          width: '300px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    handleAllOption(status) {
      if (this.selectedRowKeys.length > 0) {
        let that = this
        let strText = status == 1 ? '批量上架' : '批量下架'
        this.$confirm({
          title: '此操作将' + strText + ', 是否继续?',
          onOk() {
            that.handleOption(that.selectedRowsIdList, status)
          },
          onCancel() {
            that.$message.warning('已取消')
          }
        })
      } else {
        this.$message.warning('请选择需要操作的数据')
      }
    },
    //单独上下架
    handleUpDownOption(record, status) {
      let obj = {
        optionId: record.ratePlanOptionId,
        ratePlanIds: record.mark == 1 ? 0 : record.optionId
      }
      this.handleOption([obj], status)
    },
    //上下架接口
    handleOption(list, status) {
      let text = status == 1 ? '上架' : '下架'
      let params = {
        productId: this.proId,
        status: status,
        optionPlanIds: list
      }
      this.getHttpServices().getProService().post('api/v2/productManage/hotel/price-plan/batch/status', params).then(res => {
        this.getLogUtils().logWithTag('handleOption', res)
        this.$refs.table.refresh(true)
        this.selectedRowKeys = []
        this.selectedRows = []
        this.selectedRowsIdList = []
        if (res) {
          this.optionErrorIds = res.optionIds && res.optionIds.length > 0 ? res.optionIds : []
          this.ratePlanErrorIds = res.ratePlanIds && res.ratePlanIds.length > 0 ? res.ratePlanIds : []
          this.visibleError = true
        } else {
          this.$message.success(text + '成功')
          this.optionErrorIds = []
          this.ratePlanErrorIds = []
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //删除接口
    onDeleteType(record) {
      let params = {
        productId: this.proId,
        optionPlanIds: [{
          optionId: record.ratePlanOptionId,
          ratePlanIds: record.mark == 1 ? 0 : record.optionId
        }]
      }
      this.getHttpServices().getProService().post('api/v2/productManage/hotel/price-plan/batch/delete', params).then(res => {
        this.getLogUtils().logWithTag('onDeleteType', res)
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCopyType(optionId) {
      this.getHttpServices().getProService().post('product/option/optionCopy?optionId=' + optionId).then(res => {
        this.getLogUtils().logWithTag('onCopyType', res)
        this.$message.success('复制成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //编辑按钮
    editOption(record) {
      this.getLogUtils().logWithTag('editOption', record)
      if (record.mark == 1) {
        this.onNewClickOption(record.optionId)
      } else {
        this.onPlanUpdate(record, record.optionId)
      }
    },
    //新建 编辑房型
    onNewClickOption(optionId) {
      this.$router.push({
        name: 'HotelOptionInfo',
        query: {
          proId: this.proId,
          optionId: optionId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    },
    //新建 编辑价格计划
    onPlanUpdate(record, ratePlanId) {
      this.$router.push({
        name: 'HotelPlanInfo',
        query: {
          proId: this.proId,
          optionId: record.ratePlanOptionId,
          catalogId: this.catalogId,
          ratePlanId: ratePlanId,
          proSource: this.proSource,
          optionName: record.mark == 1 ? record.optionName : record.ratePlanOptionName
        }
      })
    },
    goSetPrice(data) {
      let name = ''
      if (this.proSource == 0) {
        name = 'NewProCalendar'
        // name = "ProOwnPrice";
      } else {
        name = 'ProNoOwnPrice'
      }
      this.$router.push({
        name,
        query: {
          proId: this.proId,
          optionId: data.ratePlanOptionId,
          ratePlanId: data.optionId,
          catalogId: this.catalogId,
          proSource: this.proSource,
          optionName: data.ratePlanOptionName
        }
      })
    },
    refreshEvent() {
      this.$refs.table.refresh(true)
    }
  }

}
</script>
<style lang="less" scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.page-box {
  .page-main {
    margin: 10px;
    display: flex;
    width: 100%;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.mr5 {
  margin-right: 5px;
}
</style>
